import React from "react";
import ComputerEngineeringHeader from "../components/Courses/ComputerEngineering/ComputerEngineeringHeader";
import ComputerEngineeringCareerSkills from "../components/Courses/ComputerEngineering/ComputerEngineeringCareerSkills";
import ComputerEngineeringProgramsCard from "../components/Courses/ComputerEngineering/ExploreProgramsComputerEngineering";
import ComputerEngineeringAdmissionRequirements from "../components/Courses/ComputerEngineering/ComputerEngineeringAdmissionRequirements";
import FullScreenImage from "../components/Home/ShowcaseSection";
import Footer from "../components/sub-comp/MainFooter";
import Navbar from "../components/sub-comp/Navbar";

const ComputerEngineering = () => {
  return (
    <div>
      <Navbar />
      <ComputerEngineeringHeader />
      <ComputerEngineeringCareerSkills />
      <ComputerEngineeringProgramsCard />
      <ComputerEngineeringAdmissionRequirements />
      <FullScreenImage />
      <Footer />
    </div>
  );
};

export default ComputerEngineering;
